var resultCategories = ['mild', 'normal', 'moderate'];
export function isResultsCategory(category) {
    if (!category)
        return false;
    return resultCategories.includes(category);
}
